import { createContext, useContext, useEffect, useState } from "react";

// Twee perspectieven, één LevelLeven-wereld.
// Deelnemer: "Waar krijg jij weer zin in?"
// Opdrachtgever: "Waar ontstaat aantoonbare beweging?"

const PerspectiveContext = createContext({
  perspective: "deelnemer",
  setPerspective: () => {},
});

export function PerspectiveProvider({ children }) {
  const [perspective, setPerspective] = useState(() => {
    if (typeof window === "undefined") return "deelnemer";
    return window.localStorage.getItem("ll-perspective") || "deelnemer";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("ll-perspective", perspective);
      document.documentElement.setAttribute("data-perspective", perspective);
    } catch {
      /* ignore */
    }
  }, [perspective]);

  return (
    <PerspectiveContext.Provider value={{ perspective, setPerspective }}>
      {children}
    </PerspectiveContext.Provider>
  );
}

export function usePerspective() {
  return useContext(PerspectiveContext);
}
